var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 59,
    viewBox: "0 0 48 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9677 0.75641C30.9677 0.338656 30.6211 0 30.1935 0H8.51613C3.8128 0 0 3.72522 0 8.32051V50.6795C0 55.2748 3.8128 59 8.51613 59H39.4839C44.1872 59 48 55.2748 48 50.6795V20.868C48 20.4503 47.6534 20.1116 47.2258 20.1116H33.2903C32.0076 20.1116 30.9677 19.0956 30.9677 17.8424V0.75641ZM33.2903 30.2564C34.573 30.2564 35.6129 31.2724 35.6129 32.5256C35.6129 33.7789 34.573 34.7949 33.2903 34.7949H14.7097C13.427 34.7949 12.3871 33.7789 12.3871 32.5256C12.3871 31.2724 13.427 30.2564 14.7097 30.2564H33.2903ZM33.2903 42.359C34.573 42.359 35.6129 43.3749 35.6129 44.6282C35.6129 45.8815 34.573 46.8974 33.2903 46.8974H14.7097C13.427 46.8974 12.3871 45.8815 12.3871 44.6282C12.3871 43.3749 13.427 42.359 14.7097 42.359H33.2903Z",
    fill: "#EB6424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6129 1.73713C35.6129 1.17891 36.2095 0.824474 36.654 1.17512C37.0285 1.47046 37.365 1.81647 37.6522 2.20735L46.9833 14.9087C47.1957 15.1979 46.9656 15.5732 46.6013 15.5732H36.3871C35.9595 15.5732 35.6129 15.2345 35.6129 14.8167V1.73713Z",
    fill: "#EB6424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStats);
export default __webpack_public_path__ + "static/media/icon-stats.955aceeaaa40dba0d412518e5251fa13.svg";
export { ForwardRef as ReactComponent };